import React, { useState, useEffect, useCallback } from "react";

import { useLoaderData } from "react-router-dom";
import PaymentElements from "pages/checkout/PaymentElements";

import LoginRegisterBox from "components/LoginRegisterBox";
import { LogLevel } from "@bugfender/sdk";
import * as Cart from 'hooks/cart';
import CartItems from './components/CartItems';


const { useCartReducer } = Cart;

const CheckoutPage = () => {
  const { state: cartState, dispatch } = useCartReducer();
  const state = useLoaderData();
  const {
    cart, user, tax, useCartLoggerEnabled, Bugfender
  } = state;
  const cartLoggerEnabled = false; // Set to true to enable Bugfender logging
  const isEmptyCart = cart.items.length === 0;

  const [cmeBlocked, setCmeBlocked] = useState(false);
  const [allAreTrialProducts, setAllAreTrialProducts] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [userInitialized, setUserInitialized] = useState(user.signed_in);

  const handleCmeBlocked = useCallback(() => {
    const requestAsync = async () => {
      try {
        cart.sync(cmeBlocked);
        if (useCartLoggerEnabled) {
          Bugfender.sendLog({
            level: LogLevel.Info,
            tag: "Checkout",
            text: 'Cart sync successful'
          });
        }
      } catch (e) {
        if (useCartLoggerEnabled) {
          Bugfender.sendLog({
            level: LogLevel.Error,
            tag: "Checkout",
            text: `Cart sync failed ${e}`
          });
        }
        console.log(e);
      }
    };

    if (cart) {
      requestAsync();
    }
  }, [cart, cmeBlocked]);

  const handleRequest = (action) => {
    dispatch(action);
  };

  useEffect(() => {
    document.title = 'Checkout';
    if (useCartLoggerEnabled) {
      Bugfender.sendLog({
        level: LogLevel.Info,
        tag: "Checkout",
        text: 'Checkout page loaded'
      });
    }
    setIsLoaded(true);
  }, []);

  useEffect(() => {
    if (!user.signed_in) {
      if (useCartLoggerEnabled) Bugfender.setDeviceKey('user_id', -1);
      return;
    }
    Bugfender.setDeviceKey('email', user.data.email);
    Bugfender.setDeviceKey('user_id', user.data.id);
  }, [user]);

  useEffect(() => {
    if (!cart) {
      return;
    }

    const allTrial = cart.items.every(item => item.product.isTrialProduct);

    setAllAreTrialProducts(allTrial);
    if (useCartLoggerEnabled) Bugfender.sendLog({ level: LogLevel.Debug, tag: "Checkout", text: `All items are trial products: ${allTrial}` });
  }, [cart]);

  useEffect(() => {
    const cartElement = document.getElementById('cart');

    if (!cartElement) {
      if (useCartLoggerEnabled) Bugfender.sendLog({ level: LogLevel.Warning, tag: "Checkout", text: 'Cart element not found' });
      return;
    }

    const blocked = cartElement.getAttribute('data-cme-blocked');

    setCmeBlocked(blocked === 'true');
    if (useCartLoggerEnabled) {
      Bugfender.sendLog({
        level: LogLevel.Info,
        tag: "Checkout",
        text: `CME blocked status: ${blocked === 'true'}`
      });
    }
  }, []);

  useEffect(() => {
    handleCmeBlocked();
  }, [cmeBlocked]);

  return (
    <div>
      <div id="checkout" className="container">
        <div className="pseudo">
          <div className="background-blue" />
        </div>
        <div>
          <div className="cart flex">
            <CartItems
              tax={tax}
              cart={cart}
              user={user}
              Bugfender={Bugfender}
              handleRequest={handleRequest}
              cartState={cartState}
            />
            { !isEmptyCart && isLoaded && (
              userInitialized
                ? <PaymentElements cartState={cartState} handleRequest={handleRequest} />
                : <LoginRegisterBox allTrial={allAreTrialProducts} setUserInitialized={setUserInitialized} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutPage;
